import { simplex } from './simplex';

/**
 * Generate random peercentage breakpoints in string format: AA%;BB%;CC%;...
 * @returns Random percentage breakpoints in string format
 */
export const getPositionVals = (): string => {
  const vals: number[] = [];

  // Perform for every degree.
  for (let i = 0; i < 360; i += 360 / 10) {
    // Get positive simplex 3D noise.
    let val = Math.abs(Math.floor(simplex.noise3D(Math.sin(i), Math.cos(i), 0) * 100));

    // First and last are always 20 and 80, respectively.
    if (val >= 0 && val < 20) {
      val = 20;
    } else if (val <= 100 && val > 80) {
      val = 80;
    }

    vals.push(val);
  }

  const percentages = vals.map((v) => `${v}%;`);

  return percentages.join('');
};
